import { EAppSettings, SelectItem } from "library/types";
import { ChangeEvent } from "react";
import { ISettingsStrings } from "./ISettingsStrings";

import {
  SelectOnChangeData,
  Switch,
  SwitchOnChangeData,
  SwitchProps,
} from "@fluentui/react-components";
import SelectField from "components/controls/SelectField";
import { Flex } from "components/styled";
import { useAppSettings } from "hooks/useAppSettings";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ThemeSelector } from "./ThemeSelector/ThemeSelector";

export interface ISettingsToggle {
  toggleProps: SwitchProps;
  title: string;
}

interface IProps {
  darkMode?: any;
  strings?: ISettingsStrings;
  languageOptions?: SelectItem[];
  defaultSelectedLanguage?: string;
  onChangeLanguage?: (
    ev: ChangeEvent<HTMLSelectElement>,
    data: SelectOnChangeData
  ) => void;
}

export const Settings = (props: IProps) => {
  const { t } = useTranslation();
  const { getSetting, updateSetting } = useAppSettings();

  const darkModeAppSetting = getSetting(EAppSettings.darkMode);

  return (
    <Container>
      {props.languageOptions && (
        <SelectField
          label={t("header.SelectLanguage")}
          appearance="filled-darker"
          name="selectValue"
          value={
            props.languageOptions.find(
              (option) => option.value === props.defaultSelectedLanguage
            ) as any
          }
          // defaultSelectedKey={props.defaultSelectedLanguage}
          options={props.languageOptions}
          setFieldValue={props.onChangeLanguage as any}
        />
      )}
      <Flex direction="column" gap={"25px"} $align="flex-start">
        <Switch
          defaultChecked={darkModeAppSetting?.userAppSettingValue === "true"}
          onChange={(_, data: SwitchOnChangeData) => {
            props.darkMode && props.darkMode(data.checked);
            updateSetting(
              EAppSettings.darkMode,
              data.checked.toString(),
              false
            );
          }}
          label={
            (props.strings && props.strings.darkModeToggleLabel) ||
            t("header.DarkMode")
          }
          indicator={{
            style: {
              marginLeft: 0,
            },
          }}
          labelPosition="after"
        />
        {/* <ThemeSelector /> */}
      </Flex>
    </Container>
  );
};

const Container = styled.div``;
